module.exports = __webpack_public_path__ + "img/ukraine-01.133f3000.svg";